export { renderDrawerHeaderTitle_unstable as renderDrawerHeaderTitle } from '@fluentui/react-drawer';
